<div class="release-notes-container">
  <h2 class="header">Driven Release Notes</h2>
  <p class="sub-header">Latest updates and changelog</p>

  <div class="release-card" *ngFor="let note of releaseNotes">
    <!-- Header -->
    <div class="release-header">
        <div class="badge-container">
            <p-tag *ngFor="let badge of note.type"
                [value]="badge"
                [severity]="getSeverity(badge)"
                styleClass="p-mr-2">
            </p-tag>
        </div>
      <span class="date">{{ note.date }}</span>
    </div>

    <!-- Title -->
    <h3 class="release-title">{{ note.title }}</h3>

    <!-- Expandable Sections -->
    <p-accordion [multiple]="true" class="release-accordion">
      <p-accordionTab header="New" *ngIf="note.new?.length; let last = last">
        <div class="new-list">
            <div class="new-item" *ngFor="let item of note.new">
                <h4 class="new-title">{{ '🆕 ' + item.title }}</h4>
                <!-- <span *ngIf="item.link_label"><p-button [label]="item.link_label" styleClass="p-button-link" (onClick)="openLink(item.link)"></p-button></span> -->
                <p class="new-description">{{ item.description }}</p>
                <hr *ngIf="!last" class="divider" />
            </div>
        </div>
      </p-accordionTab>

      <p-accordionTab header="Bug Fixes" *ngIf="note.bugfixes?.length">
        <div class="bugfixes-list">
            <div class="bugfixes-item" *ngFor="let item of note.bugfixes; let last = last">
                <h4 class="bugfixes-title">{{ '🛠️ ' + item.title }}</h4>
                <!-- <span *ngIf="item.link_label"><p-button [label]="item.link_label" styleClass="p-button-link" (onClick)="openLink(item.link)"></p-button></span> -->
                <p class="bugfixes-description">{{ item.description }}</p>
                <hr *ngIf="!last" class="divider" />
            </div>
        </div>
      </p-accordionTab>

      <p-accordionTab header="Improvements" *ngIf="note.improvements?.length">
        <div class="improvements-list">
            <div class="improvements-item" *ngFor="let item of note.improvements; let last = last">
                <h4 class="improvements-title">{{ '🎯 ' + item.title }}</h4>
                <!-- <span *ngIf="item.link_label"><p-button [label]="item.link_label" styleClass="p-button-link" (onClick)="openLink(item.link)"></p-button></span> -->
                <p class="improvements-description">{{ item.description }}</p> 
                <ul *ngIf="item.point?.length" class="sub-points">
                    <li *ngFor="let sub of item.point">{{ sub }}</li>
                </ul>
                <hr *ngIf="!last" class="divider" />
            </div>
        </div>
      </p-accordionTab>

    </p-accordion>

    <!-- Feedback -->
    <!-- <div class="feedback-row">
        <br>
        <span>
            <button pButton pRipple type="button" icon="pi pi-thumbs-up" class="p-button-rounded p-button-success" pTooltip="I like this update"></button>
        </span>
        <span>
            <button pButton pRipple type="button" icon="pi pi-thumbs-down" class="p-button-rounded p-button-danger" pTooltip="Needs improvement"></button>
        </span>
    </div> -->
  </div>
</div>